module.exports = __webpack_public_path__ + "static/media/menu.b4b82800.svg";